
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { WorkProjectdossierTemplateSortOrderItemDto } from '../models/work-projectdossier-template-sort-order-item-dto';

export function getUpdateSortOrderProjectdossierTemplatesDtoFormGroup() {
return new FormGroup({
    updates: new FormControl<WorkProjectdossierTemplateSortOrderItemDto[]>([]),
})
;
}
      